var map = {
	"./Holzunterkonstruktion.svg": 1648,
	"./Holzunterkonstruktion_weiss.svg": 7505,
	"./Stahlunterkonstruktion.svg": 7347,
	"./Stahlunterkonstruktion_weiss.svg": 2334,
	"./info.svg": 1710,
	"./tick.svg": 2186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;